import { StyledForm } from '@framework/form';
import { t } from '@framework/i18n';
import { Drawer } from '@framework/ui';
import { Button, Space } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { RichTextAdvancedRender } from '../../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { DrawerButtonRow } from '../../../../../../../ui/drawer';
import { ISubsectionWidget } from '../../ISubsectionWidget';

const StyledSubsectionDrawerBodyWrapper = styled.div`
  max-width: ${props => props.theme.contentMaxWidth}px;
  margin: 0 auto;
`;

export interface ISubsectionDrawerProps {
  widget: ISubsectionWidget;
  children?: React.ReactNode;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export function SubsectionDrawer(props: ISubsectionDrawerProps) {
  const { widget, isOpen, setIsOpen } = props;
  return (
    <Drawer
      title={<RichTextAdvancedRender text={widget.label ?? 'Sottosezione'} />}
      size="large"
      width="90%"
      placement="right"
      onClose={() => {
        setIsOpen(false);
      }}
      open={isOpen}
      maskClosable={false}
    >
      <StyledSubsectionDrawerBodyWrapper>
        <StyledForm>{props.children}</StyledForm>
      </StyledSubsectionDrawerBodyWrapper>
      <DrawerButtonRow>
        <Space>
          <Button type="primary" size="large" onClick={() => setIsOpen(false)}>
            {t('subsection.drawer.button.back', 'Indietro')}
          </Button>
        </Space>
      </DrawerButtonRow>
    </Drawer>
  );
}
